<template>
    <span class="px-1">
        <text-field
            v-if="control_type === 'text'"
            :value="field.value"
            :label="field.title"
            :error-messages="field.value_error"
            append-icon="mdi-close-circle"
            @input="field.value = $event"
            @click:append="removeItem()"
        />
        <text-field
            v-if="control_type === 'number'"
            :value="field.value_f"
            :error-messages="field.value_error"
            :label="field.title"
            append-icon="mdi-close-circle"
            @keypress="filterNumber"
            @input="number_field_changed"
            @click:append="removeItem()"
        />
        <date-picker
            v-else-if="control_type === 'date'"
            clearable
            :value="field.value"
            :label="field.title"
            @input="field.value = $event"
        />
        <dropdown
            v-else-if="control_type === 'dropdown'"
            :items="items"
            :selected="items.filter(x => x[item_value] === field.value)"
            name-key="name"
            :value-key="item_value"
            show-selected-first
            :error-messages="field.value_error"
            :label="field.title"
            append-icon="mdi-close-circle"
            @input="field.value = $event[item_value]"
            @click:append="removeItem()"
        />
        <div v-else-if="control_type === 'checkbox'" class="pt-2">
            <checkbox
                :value="field.value"
                :error-messages="field.value_error"
                @change="field.value = $event"
            >
                {{ field.title }}
                <v-icon size="16" class="ml-3" @click="removeItem">
                    mdi-close-circle
                </v-icon>
            </checkbox>
        </div>
    </span>
</template>

<script>
import errorDialog from "@/views/ErrorDialog/errorDialog"
import { computed } from "@vue/composition-api";
import { $t } from "@/i18n";
import AppModule from "../../../../store/modules/app";
import { cleanNumber } from "@/plugins/formatting";
import { filterNumber } from "@/helpers/helpers";
import {useMemberStore} from "../../../../store/modules/member";

export default {
    name: "FieldControl",
    components: {},
    props: {
        field: {
            type: Object,
            required: true
        },
        accountId: {
            type: Number,
            required: true
        }
    },
    setup(props, ctx) {
        const appModule = AppModule();
        const memberStore = useMemberStore()

        const control_type = computed(function() {
            if (props.field.parser_type === "date") return "date";
            if (props.field.parser_type === "number") return "number";
            if (props.field.parser_type === "boolean") return "checkbox";
            if (["reference_id",
                 "choice_single",
                 "choice_multi",
                 "locale_code",
                 "country_code"].includes(props.field.parser_type)) return "dropdown";
            return "text";
        });

        const items = computed(function() {
            if (["choice_single", "choice_multi"].includes(props.field.parser_type)) {
                return props.field.choices;
            } else {
                if (classifier_name.value == null) return;

                if (classifier_name.value == "client_groups") {
                    if (appModule[classifier_name.value].value[props.accountId] != undefined)
                        return appModule[classifier_name.value].value[props.accountId];
                } else if (classifier_name.value === "account_members") {
                    return memberStore.getMembersByCompany(props.accountId)
                } else {
                    if (appModule[classifier_name.value].value != undefined)
                        return appModule[classifier_name.value].value;
                }
                return [];
            }
        });

        const item_value = computed(function() {
            if (props.field.parser_type == "choice_single"
                || props.field.parser_type == "language"
                || props.field.parser_type == "country_code"
            ) {
                return "code";
            } else {
                return "id";
            }
        });
        const classifier_name = computed(function() {
            let cl_name = null;
            if (props.field.parser_type == "language") cl_name = "languages"
            if (props.field.parser_type == "country_code") cl_name = "countries"
            if (props.field.parser_type == "client_groups") cl_name = "client_groups"
            if (props.field.parser_type == "members") cl_name = "account_members"
            return cl_name;
        });

        const load_data = function() {
            if (classifier_name.value == null) return;
            appModule
                .fetchClassifiers({ types: [classifier_name.value], account_id: props.accountId })
                .catch(function(ex) {
                    errorDialog.showError(ex);
                });
        };
        const number_field_changed = function(data) {
            var num_str = cleanNumber(data);
            if (isNaN(num_str)) {
                props.field.field_error = $t("Must be a number");
                props.field.field = 0;
            } else {
                props.field.field_error = null;
                props.field.field = parseFloat(num_str);
            }
        };

        const removeItem = () => {
            ctx.emit('remove')
        }

        load_data();

        return {
            control_type,
            items,
            item_value,
            number_field_changed,
            filterNumber,
            removeItem
        };
    }
};
</script>

<style scoped lang="scss">
::v-deep .v-input {
    .v-input__append-inner {
        margin-top: 9px !important;

        .mdi-close-circle {
            font-size: 18px !important;
        }
    }
}
</style>